export const TwampConfigFieldMapping = {
  ALIAS: 'alias',
  CUSTOMER: 'customer',
  CONTACT: 'contact',
  EMAIL: 'email',
  PHONE: 'phone',
  TECHINICIAN: 'technician',
  TECHINICIANID: 'technicianId',
  TEST_TYPE: 'testType',
  RUN_TYPE: 'runType',
  AGENT_TYPE: 'agentType',
  SELECTED_ORIGINATOR: 'selectedOriginator',
  TRANSMIT_INTERFACE: 'tx-interface',
  MAC_ADDRESS: 'mac-address',
  NETWORK_MAC: 'network_mac',
  EQUIPMENT_MAC: 'equipment_mac',
  DEFINED_ADDRESS: 'defined-address',
  ASSIGNED_IP_ADDRESS: 'assigned-ip',
  ADDRESS: 'address',
  SUBNET: 'subnet',
  GATEWAY: 'gateway',
  BASE_UDP: 'baseUdp',
  SELECTED_DESTINATION: 'selectedDestination',
  SELECTED_DESTINATION_AGENTS: 'selectedDestinationAgents',
  VLAN_CONFIG: 'vlanConfig',
  SVLAN_ID: 'vlan-id',
  SVLAN_PRIORITY: 'vlan-priority',
  CVLAN_ID: 'inner-vlan-id',
  CVLAN_PRIORITY: 'inner-vlan-priority',
  CVLAN_ETHER_TYPE: 'tpid',
  IP_ADDRESS_TYPE: 'ipAddressType',
  PM_INTERVAL: 'twamp-keep-alive-interval',
  CODEC: 'codec',
  ENABLE_PERCENTILES: 'enable-percentiles',
  PAYLOAD_TYPE: 'payload-type',
  DF_BIT: 'df-bit',
  KEEP_ALIVE: 'keep-alive',
  REBOOT: 'reboot',
  REFLECTOR_UDP: 'reflector-udp',
  SPECIFIC_FLOWS: 'specificFlows',
  COMMON_FLOWS: 'commonFlows',
  SELECTED_TAB: 'selectedTab',
  SELECTED_REFLECTOR_IDS: 'selectedReflectedIds'
};

export const DSCP_FLOWS = [
  {
    value: 'Best effort',
    id: 0
  },
  {
    value: 'Class Selector 1',
    id: 8
  },
  {
    value: 'AF 11',
    id: 10
  },
  {
    value: 'AF 12',
    id: 12
  },
  {
    value: 'AF 13',
    id: 14
  },
  {
    value: 'Class Selector 2',
    id: 16
  },
  {
    value: 'AF 21',
    id: 18
  },
  {
    value: 'AF 22',
    id: 20
  },
  {
    value: 'AF 23',
    id: 22
  },
  {
    value: 'Class Selector 3',
    id: 24
  },
  {
    value: 'AF 31',
    id: 26
  },
  {
    value: 'AF 32',
    id: 28
  },
  {
    value: 'AF 33',
    id: 30
  },
  {
    value: 'Class Selector 4',
    id: 32
  },
  {
    value: 'AF 41',
    id: 34
  },
  {
    value: 'AF 42',
    id: 36
  },
  {
    value: 'AF 43',
    id: 38
  },
  {
    value: 'Class Selector 5',
    id: 40
  },
  {
    value: 'AF 51',
    id: 42
  },
  {
    value: 'AF 52',
    id: 44
  },
  {
    value: 'Exp. Forwarding',
    id: 46
  },
  {
    value: 'Class Selector 6',
    id: 48
  },
  {
    value: 'Class Selector 7',
    id: 56
  }
];

export const TX_INTERVAL = [
  {
    value: '10 ms',
    id: 10
  },
  {
    value: '20 ms',
    id: 20
  },
  {
    value: '100 ms',
    id: 100
  },
  {
    value: '1 s',
    id: 1000
  },
  {
    value: '2 s',
    id: 2000
  }
];
export const JMEP_TX_INTERVAL = [
  {
    value: '10 ms',
    id: 10
  },
  {
    value: '100 ms',
    id: 100
  },
  {
    value: '1 s',
    id: 1000
  },
  {
    value: '10 s',
    id: 10000
  }
];
export const CONFIRM_SELECTION = [
  { name: 'Yes', value: true },
  { name: 'No', value: false }
];

export const PM_INTERVAL = [
  {
    value: '1 minute',
    id: 60
  },
  {
    value: '5 minute',
    id: 300
  },
  {
    value: '15 minute',
    id: 900
  }
];
export interface DSCP_FLOWS_TYPE {
  id?: number;
  value?: string;
  checked?: boolean;
  frameSize?: number;
  txInterval?: string;
  padding?: number;
}

export const MOS_CODEC_CONFIG = [
  {
    id: 'none',
    value: 'None'
  },
  {
    id: 'G.711_64_kbps',
    value: 'G.711 64kb/s'
  },
  {
    id: 'G.723.1_5.3_kbps',
    value: 'G.723.1 5.3 kb/s'
  },
  {
    id: 'G.726_24_kbps',
    value: 'G.726 24 kb/s'
  },
  {
    id: 'G.729_8_kbps',
    value: 'G.729 8 kb/s'
  },
  {
    id: 'generic',
    value: 'Generic'
  }
];
export enum MOS_CONFIG {
  NONE = 'none',
  GENERIC = 'generic'
}

export const DEFAULT_FLOWS = [
  {
    name: 'flow',
    dscp: DSCP_FLOWS[0].id,
    frameSize: 512,
    txInterval: 100,
    padding: 425,
    paddingMin: 0,
    paddingMax: 8913,
    frameSizeMin: 87,
    frameSizeMax: 9000,
    dfBit: true,
    reflectorUDP: 50000
  }
];

export enum vlanConfigLabel {
  UNTAGGED = 'Untagged',
  SINGLE_VLAN = 'Single VLAN',
  Q_IN_Q = 'Q-in-Q'
}

export enum vlanConfigValue {
  UNTAGGED = 'untagged',
  SINGLE_VLAN = 'tagged',
  Q_IN_Q = 'q_in_q'
}

export enum ETHER_TYPE_LABEL {
  ETHER_8100 = '8100',
  ETHER_88a8 = '88a8',
  ETHER_9100 = '9100'
}

export const VLAN_CONFIG_TYPE = [
  { name: vlanConfigLabel.UNTAGGED, value: vlanConfigValue.UNTAGGED },
  { name: vlanConfigLabel.SINGLE_VLAN, value: vlanConfigValue.SINGLE_VLAN },
  { name: vlanConfigLabel.Q_IN_Q, value: vlanConfigValue.Q_IN_Q }
];

export const ETHER_TYPE = [
  { name: '8100', value: ETHER_TYPE_LABEL.ETHER_8100 },
  { name: '88a8', value: ETHER_TYPE_LABEL.ETHER_88a8 },
  { name: '9100', value: ETHER_TYPE_LABEL.ETHER_9100 }
];

export enum IPAddressValue {
  IP_V4 = 'ipv4',
  IP_V6 = 'ipv6'
}
export enum IPAddressLabel {
  IP_V4 = 'IPv4',
  IP_V6 = 'IPv6'
}
export enum definedAddressLabel {
  TEST_IP = 'Test IP',
  MANAGEMENT_IP = 'Management IP',
  MANUAL = 'Manual'
}

export enum definedAddressValue {
  TEST_IP = 'testIP',
  MANAGEMENT_IP = 'managed',
  MANUAL = 'manual'
}

export enum TRANSMIT_INTERFACE_LABEL {
  EQUIPMENT = 'Equipment',
  NETWORK = 'Network'
}

export enum TRANSMIT_INTERFACE_VALUE {
  EQUIPMENT = 'equipment',
  NETWORK = 'network'
}

export enum TX_IMAGE {
  EQUIPMENT = 'images/equipment.png',
  NETWORK = 'images/network.png'
}

export const TRANSMIT_INTERFACE_TYPE = [
  { name: TRANSMIT_INTERFACE_LABEL.EQUIPMENT, value: TRANSMIT_INTERFACE_VALUE.EQUIPMENT },
  { name: TRANSMIT_INTERFACE_LABEL.NETWORK, value: TRANSMIT_INTERFACE_VALUE.NETWORK }
];

export const DEFINED_ADDRESS_TYPES = [
  { name: definedAddressLabel.TEST_IP, value: definedAddressValue.TEST_IP, enabled: true },
  {
    name: definedAddressLabel.MANAGEMENT_IP,
    value: definedAddressValue.MANAGEMENT_IP,
    enabled: true
  }
];
